(function () {
  var root = document.querySelector('[data-email-login]');

  if (!root || !window.emailLoginRoutes) {
    return;
  }

  var passwordView = document.getElementById('login-password-view');
  var passkeyView = document.getElementById('login-passkey-view');

  var requestView = document.getElementById('login-email-request-view');
  var sentView = document.getElementById('login-email-sent-view');
  var codeView = document.getElementById('login-email-code-view');

  var openButton = document.getElementById('email-login-open');
  var requestForm = document.getElementById('email-login-request-form');
  var requestEmailInput = document.getElementById('email-login-email');

  var passwordEmailInput = document.getElementById('email');
  var passkeyEmailInput = document.getElementById('passkey-email');

  var sentAddress = document.getElementById('email-login-sent-address');
  var codeAddress = document.getElementById('email-login-code-address');

  var useCodeButton = document.getElementById('email-login-use-code');
  var verifyButton = document.getElementById('email-login-verify');

  var resendButton = document.getElementById('email-login-resend');
  var codeResendButton = document.getElementById('email-login-code-resend');

  var changeEmailButton = document.getElementById('email-login-change-email');
  var backPasswordButton = document.getElementById('email-login-back-password');
  var codeBackButton = document.getElementById('email-login-code-back');

  var errorElement = document.getElementById('email-login-error');

  var codeInputs = Array.prototype.slice.call(
    document.querySelectorAll('.email-login-code__input')
  );

  var currentEmail = '';
  var requestId = null;

  function csrfToken() {
    var element = document.querySelector('meta[name="csrf-token"]');

    return element ? element.getAttribute('content') : '';
  }

  function hideAllViews() {
    [
      passwordView,
      passkeyView,
      requestView,
      sentView,
      codeView
    ].forEach(function (view) {
      if (view) {
        view.classList.add('d-none');
      }
    });
  }

  function showView(view) {
    hideAllViews();
    clearError();

    if (view) {
      view.classList.remove('d-none');
    }
  }

  function showError(message) {
    if (!errorElement) {
      return;
    }

    errorElement.textContent = message || 'Something went wrong.';
    errorElement.classList.remove('d-none');
  }

  function clearError() {
    if (!errorElement) {
      return;
    }

    errorElement.textContent = '';
    errorElement.classList.add('d-none');
  }

  function setLoading(button, loading) {
    if (!button) {
      return;
    }

    if (!button.dataset.originalText) {
      button.dataset.originalText = button.innerHTML;
    }

    button.disabled = loading;

    if (loading) {
      button.textContent = 'Please wait...';
    } else {
      button.innerHTML = button.dataset.originalText;
    }
  }

  async function post(url, payload) {
    var response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': csrfToken(),
      },
      body: JSON.stringify(payload),
    });

    var data = {};

    try {
      data = await response.json();
    } catch (e) {
      data = {};
    }

    if (!response.ok) {
      var error = new Error(
        data.message || 'Something went wrong.'
      );

      error.response = data;
      error.status = response.status;

      throw error;
    }

    return data;
  }

  async function requestEmail(email, button) {
    setLoading(button, true);
    clearError();

    try {
      var data = await post(
        window.emailLoginRoutes.request,
        {
          email: email,
        }
      );

      currentEmail = email;
      requestId = data.request_id;

      if (sentAddress) {
        sentAddress.textContent = currentEmail;
      }

      if (codeAddress) {
        codeAddress.textContent = currentEmail;
      }

      showView(sentView);

      return true;
    } catch (error) {
      showError(error.message);

      return false;
    } finally {
      setLoading(button, false);
    }
  }

  function clearCode() {
    codeInputs.forEach(function (input) {
      input.value = '';
    });
  }

  function codeValue() {
    return codeInputs
      .map(function (input) {
        return input.value;
      })
      .join('');
  }

  if (openButton) {
    openButton.addEventListener('click', function () {
      var email = '';

      if (passwordEmailInput && passwordEmailInput.value) {
        email = passwordEmailInput.value.trim();
      } else if (
        passkeyEmailInput &&
        passkeyEmailInput.value
      ) {
        email = passkeyEmailInput.value.trim();
      }

      requestEmailInput.value = email;

      showView(requestView);

      requestEmailInput.focus();
    });
  }

  if (requestForm) {
    requestForm.addEventListener('submit', async function (event) {
      event.preventDefault();

      var email = requestEmailInput.value.trim();

      if (!email) {
        return;
      }

      var button = requestForm.querySelector(
        'button[type="submit"]'
      );

      await requestEmail(email, button);
    });
  }

  if (useCodeButton) {
    useCodeButton.addEventListener('click', function () {
      clearCode();

      showView(codeView);

      if (codeInputs[0]) {
        codeInputs[0].focus();
      }
    });
  }

  if (verifyButton) {
    verifyButton.addEventListener('click', async function () {
      var code = codeValue();

      if (!requestId || code.length !== 6) {
        showError('Please enter the 6-digit code.');

        return;
      }

      setLoading(verifyButton, true);
      clearError();

      try {
        var data = await post(
          window.emailLoginRoutes.verifyCode,
          {
            request_id: requestId,
            code: code,
          }
        );

        window.location.assign(data.redirect);
      } catch (error) {
        clearCode();

        if (codeInputs[0]) {
          codeInputs[0].focus();
        }

        showError(error.message);

        if (
          error.response &&
          error.response.requires_new_code
        ) {
          requestId = null;
        }
      } finally {
        setLoading(verifyButton, false);
      }
    });
  }

  async function resend(button) {
    if (!currentEmail) {
      showView(requestView);

      return;
    }

    await requestEmail(currentEmail, button);
  }

  if (resendButton) {
    resendButton.addEventListener('click', function () {
      resend(resendButton);
    });
  }

  if (codeResendButton) {
    codeResendButton.addEventListener('click', async function () {
      var success = await requestEmail(
        currentEmail,
        codeResendButton
      );

      if (success) {
        clearCode();
        showView(codeView);

        if (codeInputs[0]) {
          codeInputs[0].focus();
        }
      }
    });
  }

  if (changeEmailButton) {
    changeEmailButton.addEventListener('click', function () {
      requestId = null;
      clearCode();

      showView(requestView);

      requestEmailInput.focus();
    });
  }

  if (backPasswordButton) {
    backPasswordButton.addEventListener('click', function () {
      showView(passwordView);
    });
  }

  if (codeBackButton) {
    codeBackButton.addEventListener('click', function () {
      showView(sentView);
    });
  }

  var codeContainer = document.getElementById('email-login-code');

  function setCodeValue(value) {
    var digits = String(value || '')
      .replace(/\D/g, '')
      .slice(0, codeInputs.length);

    codeInputs.forEach(function (input, index) {
      input.value = digits[index] || '';
    });

    if (!digits.length) {
      if (codeInputs[0]) {
        codeInputs[0].focus();
      }

      return;
    }

    if (digits.length >= codeInputs.length) {
      codeInputs[codeInputs.length - 1].focus();
    } else {
      codeInputs[digits.length].focus();
    }
  }

  if (codeContainer) {
    codeContainer.addEventListener('paste', function (event) {
      var clipboardData = event.clipboardData || window.clipboardData;

      if (!clipboardData) {
        return;
      }

      var text = clipboardData.getData('text');
      var digits = text.replace(/\D/g, '');

      if (!digits) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      setCodeValue(digits);
    });
  }

  codeInputs.forEach(function (input, index) {
    input.addEventListener('input', function () {
      var value = input.value.replace(/\D/g, '');

      if (value.length > 1) {
        setCodeValue(value);

        return;
      }

      input.value = value.slice(0, 1);

      if (
        input.value &&
        index < codeInputs.length - 1
      ) {
        codeInputs[index + 1].focus();
      }
    });

    input.addEventListener('keydown', function (event) {
      if (
        event.key === 'Backspace' &&
        !input.value &&
        index > 0
      ) {
        codeInputs[index - 1].value = '';
        codeInputs[index - 1].focus();

        return;
      }

      if (
        event.key === 'ArrowLeft' &&
        index > 0
      ) {
        event.preventDefault();
        codeInputs[index - 1].focus();

        return;
      }

      if (
        event.key === 'ArrowRight' &&
        index < codeInputs.length - 1
      ) {
        event.preventDefault();
        codeInputs[index + 1].focus();

        return;
      }

      if (event.key === 'Enter') {
        event.preventDefault();

        if (verifyButton) {
          verifyButton.click();
        }
      }
    });

    input.addEventListener('focus', function () {
      input.select();
    });
  });
})();
